// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"21ce435e","596":"69cbf553"}[chunkId] + ".chunk.css";
};